import { createAction } from 'redux-actions';

export const GetListSeminarRegisteredRequested = createAction('GET_LIST_SEMINAR_REGISTERED_VIEWER_REQUESTED');
export const GetListSeminarRegisteredReceived = createAction('GET_LIST_SEMINAR_REGISTERED_VIEWER_RECEIVED');
export const GetListSeminarRegisteredReceivedFailure = createAction('GET_LIST_SEMINAR_REGISTERED_VIEWER_RECEIVED_FAILURE');
export const ClearListSeminarRegistered = createAction('CLEAR_LIST_SEMINAR_REGISTERED_VIEWER');

export const GetDetailSeminarRegisteredRequested = createAction('GET_DETAIL_SEMINAR_REGISTERED_VIEWER_REQUESTED');
export const GetDetailSeminarRegisteredReceived = createAction('GET_DETAIL_SEMINAR_REGISTERED_VIEWER_RECEIVED');
export const GetDetailSeminarRegisteredReceivedFailure = createAction('GET_DETAIL_SEMINAR_REGISTERED_VIEWER_RECEIVED_FAILURE');
export const ClearDetailSeminarRegistered = createAction('CLEAR_DETAIL_SEMINAR_REGISTERED_VIEWER');
